import { Suspense, lazy } from "react";
import { LandingHeader } from "@/components/landing/LandingHeader";
import { HeroSection } from "@/components/landing/HeroSection";
import { SEOHead } from "@/components/SEOHead";

import { DetailedFeatures } from "@/components/landing/DetailedFeatures";

import { PricingFAQSection } from "@/components/landing/PricingFAQSection";
import { LandingProductDemo } from "@/components/landing/LandingProductDemo";

// Lazy-load below-the-fold sections to improve FCP

const ResultsSection = lazy(() => import("@/components/landing/ResultsSection").then(m => ({ default: m.ResultsSection })));
const FinalCTA = lazy(() => import("@/components/landing/FinalCTA").then(m => ({ default: m.FinalCTA })));
const LandingFooter = lazy(() => import("@/components/landing/LandingFooter").then(m => ({ default: m.LandingFooter })));

const Index = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Ulture Pest | Versión anterior de la web"
        description="Versión anterior de la web de Ulture Pest: gestión de plagas, tratamientos agrícolas, trazabilidad, inventario y control operativo."
        canonical="/legacy"
        noIndex
        schemaJson={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Ulture Pest",
            "url": "https://ulturepest.co/",
            "description": "Ulture Pest es un software para la gestión de plagas, tratamientos agrícolas, trazabilidad, inventario y control operativo en empresas agrícolas."
          },
          {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Ulture Pest",
            "applicationCategory": "BusinessApplication",
            "operatingSystem": "Web",
            "url": "https://ulturepest.co/",
            "description": "Software para la gestión de plagas, tratamientos agrícolas, trazabilidad e inventario."
          }
        ]}
      />
      
      <LandingHeader />
      <main>
        <HeroSection />
        <LandingProductDemo />
        <DetailedFeatures />
        <PricingFAQSection />
        <Suspense fallback={null}>
          <div className="hidden md:block">
            <ResultsSection />
          </div>
          <FinalCTA />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <LandingFooter />
      </Suspense>
    </div>
  );
};

export default Index;
